import styles from "@/components/ui/skeletons/EVsCardItemVariantSkeleton.module.css";

const EVsCardItemVariantSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.group1}>
        <div className={styles.headerRow}>
          <div className={styles.nameSkeleton}/>
          <div className={styles.headerAttributeSkeleton}/>
        </div>
        <div className={styles.headerRow}>
          <div className={styles.variantSkeleton}/>
          <div className={styles.yearSkeleton}/>
        </div>
        <div className={styles.headerRow}>
          <div className={styles.headerAttributeSkeleton}/>
          <div className={styles.priceSkeleton}/>
        </div>
      </div>


      <div className={styles.picture}>
        <div className={styles.imageSkeleton}/>
      </div>

      <div className={styles.attributesSkeleton}>
        <div className={styles.attributeSkeleton}/>
        <div className={styles.attributeSkeleton}/>
        <div className={styles.attributeSkeleton}/>
      </div>
    </div>
  );
};

export default EVsCardItemVariantSkeleton;
